import React from "react";
import { FaBriefcase, FaRegNewspaper, FaChartBar, FaPuzzlePiece, FaSun, FaCalendarAlt } from "react-icons/fa";

const features = [
  {
    icon: <FaBriefcase size={24} />,
    title: " Circuit Design & Simulation",
    description: "Designing analog and digital circuits Simulating circuits using LTSpice, MATLAB Simulink, or other EDA tools Optimizing circuits for reliability and cost."
  },
  {
    icon: <FaRegNewspaper size={24} />,
    title: "Electrical Drafting & CAD Services",
    description: "Creating detailed Single Line Diagrams (SLDs), wiring diagrams, and PCB layouts.Using AutoCAD Electrical, CADE, or similar tools for precise drawings"
  },
  {
    icon: <FaChartBar size={24} />,
    title: "Power System Analysis",
    description: "Load flow studies, fault analysis, and short-circuit calculations.Protection system design and coordination studies"
  },
  {
    icon: <FaPuzzlePiece size={24} />,
    title: " Substation & Transmission Design",
    description: "Layout design for high-voltage substations (132kV, 220kV, 500kV).Equipment selection and integration."
  },
  {
    icon: <FaSun size={24} />,
    title: "Control & Automation Solutions",
    description: "Developing control panel layouts and PLC programming basics.IoT-based monitoring systems for motors or grids."
  },
  {
    icon: <FaCalendarAlt size={24} />,
    title: "Safety & Compliance Consulting",
    description: "Performing risk assessments and ensuring compliance with HSE standards.Preparing safety documentation and procedures."
  }
];

const RightPage7 = () => {
  return (
    <div id="Services">
        <div className='px-6 py-12'>
            <h2 className="text-3xl font-bold text-black relative inline-block">
        Services
        {/* Underline */}
        <span className="block w-10 h-1 bg-blue-400 mt-2"></span>
      </h2>
        </div>
    <div className="max-w-6xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start space-x-4">
            <div className="flex-shrink-0 bg-blue-500 text-white rounded-full p-3">
              {feature.icon}
            </div>
            <div>
              <h3 className="text-lg font-bold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default RightPage7;
